import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import './index.scss';

/**
 * Revenue management details (contracts) list
 * Shows existing contracts, allows to edit or delete
 */
function RevenueManagementList({ onEditClick }) {
  const handleEditClick = useCallback(
    event => {
      const { year, regionId } = event?.target?.dataset ?? {};
      if (!year || !regionId) return;
      onEditClick(Number(year), Number(regionId));
    },
    [onEditClick],
  );

  return (
    <Box className="rev-mgmt-list__wrapper">
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Box>I am some fake row</Box>
        &nbsp;&nbsp;
        <Button
          color="secondary"
          variant="outlined"
          onClick={handleEditClick}
          data-region-id="2"
          data-year="2026"
        >
          Edit
        </Button>
      </Box>
    </Box>
  );
}

RevenueManagementList.propTypes = {
  onEditClick: PropTypes.func.isRequired,
};

export default memo(RevenueManagementList);
